// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"textOverflowTooltip_textWrapper__2KSnh","tooltip":"textOverflowTooltip_tooltip__37JuK"};